{
  "bell.title": "Notifications",
  "bell.open": "Show notifications",
  "bell.unread.one": "{count} unread",
  "bell.unread.other": "{count} unread",
  "bell.awaiting.one": "{count} waiting for an answer",
  "bell.awaiting.other": "{count} waiting for an answer",
  "bell.empty": "Nothing new right now.",
  "bell.empty_hint": "New bookings, reschedules and cancellations show up here.",
  "bell.mark_all_read": "Mark all as read",
  "bell.settings": "Notification settings",
  "bell.error": "The notifications could not be loaded.",
  "bell.confirm": "Confirm",
  "bell.reject": "Reject",
  "bell.reject_reason": "Rejected by the workshop",
  "bell.handled": "Already handled",
  "bell.unknown_customer": "Customer without a name",
  "bell.unknown_service": "Service",
  "bell.kind.booking_requested": "New booking to confirm",
  "bell.kind.booking_created": "New booking",
  "bell.kind.booking_rescheduled": "The customer moved their time",
  "bell.kind.booking_cancelled": "The customer cancelled",
  "bell.kind.email_failed": "The email did not arrive",
  "bell.body.booking_requested": "{customer} wants to book {service} {when}. Confirm or reject.",
  "bell.body.booking_created": "{customer} booked {service} {when}.",
  "bell.body.booking_rescheduled": "{customer} moved {service} to {when}.",
  "bell.body.booking_cancelled": "{customer} cancelled {service} {when}.",
  "bell.body.email_failed": "An email bounced. The customer does not know about their booking — call them.",
  "settings.nav.notifications": "Notifications",
  "settings.notifications.heading": "Your notifications",
  "settings.notifications.body": "This is about you, not the workshop. Changing it here changes nothing for your colleagues.",
  "settings.notifications.sound": "Play a sound",
  "settings.notifications.sound_hint": "A short chime when something new arrives. Useful on a tablet at the counter.",
  "settings.notifications.test_sound": "Test the sound",
  "settings.notifications.desktop": "Show a desktop notification",
  "settings.notifications.desktop_hint": "Visible even when the tab is in the background. The browser asks permission first.",
  "settings.notifications.desktop_blocked": "The browser has blocked notifications. Allow them in the browser's own settings.",
  "settings.notifications.kinds": "What do you want to hear about?",
  "settings.notifications.kinds_hint": "Unticked events still reach the bell, just without a sound.",
  "settings.notifications.sound_blocked": "The browser would not let the sound play. Click anywhere on the page and try again.",
  "notifications.all_caught_up": "All read. Nothing is waiting for an answer.",
  "notifications.filter.all": "Everything",
  "notifications.filter.unread_only": "Unread only",
  "notifications.load_more": "Show more",
  "notifications.empty_filtered": "Nothing matches the filter.",
  "notifications.empty_filtered_hint": "Try a different selection, or choose Everything to see the whole list.",
  "notifications.to_calendar": "To the calendar",
  "notifications.messaging.test_message": "ColorGlo: test message from the Integrations page.",
  "notifications.sms.booking_confirmed": "Your appointment at {workshop_name} is booked: {date} at {time}, {location}. Reference {reference}. Change or cancel: {manage_link}",
  "notifications.sms.reminder": "Reminder: you have an appointment at {workshop_name} on {date} at {time}, {location}. Change or cancel: {manage_link}",
  "notifications.sms.rescheduled": "Your appointment at {workshop_name} has moved to {date} at {time}. See the booking: {manage_link}",
  "notifications.sms.cancelled": "Your appointment at {workshop_name} on {date} at {time} is cancelled. You are welcome to book a new time.",
  "bell.kind.shop_order_approved": "Order approved",
  "bell.kind.shop_order_rejected": "Order rejected",
  "bell.kind.shop_order_shipped": "Order shipped",
  "bell.body.shop_order_approved": "HQ has approved order {number}.",
  "bell.body.shop_order_rejected": "HQ has rejected order {number}.",
  "bell.body.shop_order_shipped": "Order {number} has shipped. The delivery note is on the order.",
  "bell.kind.shop_order_cancelled": "Order cancelled by HQ",
  "bell.body.shop_order_cancelled": "HQ has cancelled order {number}."
}
